import { api } from './axios'
import type {
  ActivateUserResponseDto,
  DisableMfaResponseDTO,
  EnableMfaResponseDTO,
  GetUsersResponse,
  MfaStatusResponseDTO,
  SetupUserDriveResponseDto,
  SuspendUserResponseDto,
  TransferPrimaryAdminDto,
  TransferPrimaryAdminResponseDto,
  UpdateProfileDto,
  UpdateProfileResponseDto,
  UserFilters,
} from './types'

// Get all users in tenant
export const getUsers = async (params?: UserFilters): Promise<GetUsersResponse> => {
  const response = await api.get('/users', { params })

  return response.data
}

// Suspend a user
export const suspendUser = async (userId: string): Promise<SuspendUserResponseDto> => {
  const response = await api.patch(`/users/${userId}/suspend`)

  return response.data
}

// Activate a user
export const activateUser = async (userId: string): Promise<ActivateUserResponseDto> => {
  const response = await api.patch(`/users/${userId}/activate`)

  return response.data
}

// Update user profile (admin only)
export const updateUserProfile = async (
  userId: string,
  data: UpdateProfileDto,
): Promise<UpdateProfileResponseDto> => {
  const response = await api.patch(`/users/${userId}/profile`, data)

  return response.data
}

// MFA Management
export const enableMfa = async (): Promise<EnableMfaResponseDTO> => {
  const response = await api.post('/users/me/mfa/enable')

  return response.data
}

export const disableMfa = async (): Promise<DisableMfaResponseDTO> => {
  const response = await api.post('/users/me/mfa/disable')

  return response.data
}

export const getMfaStatus = async (): Promise<MfaStatusResponseDTO> => {
  const response = await api.get('/users/me/mfa/status')

  return response.data
}

// Transfer primary admin role
export const transferPrimaryAdmin = async (
  data: TransferPrimaryAdminDto,
): Promise<TransferPrimaryAdminResponseDto> => {
  const response = await api.post('/users/admin/transfer', data)

  return response.data
}

// Delete a user
export const deleteUser = async (
  userId: string,
): Promise<{
  userId: string
  email: string
  status: string
  deletedAt: string
  message: string
}> => {
  const response = await api.delete(`/users/${userId}`)

  return response.data
}

// Setup user drive
export const setupUserDrive = async (userId: string): Promise<SetupUserDriveResponseDto> => {
  const response = await api.post(`/users/${userId}/setup-drive`)

  return response.data
}
